import { render, staticRenderFns } from "./ViewLog.vue?vue&type=template&id=12047d30"
import script from "./ViewLog.vue?vue&type=script&lang=js"
export * from "./ViewLog.vue?vue&type=script&lang=js"
import style0 from "./ViewLog.vue?vue&type=style&index=0&id=12047d30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports